{
  "blog": {
    "title": "Blog",
    "description": "Manage posts, categories and hashtags for Printway's public blog. Schedule publishing in UTC; a cron job auto-flips Draft → Published when the time comes.",
    "tabsAriaLabel": "Blog tabs",
    "tabs": {
      "posts": "Posts",
      "categories": "Categories",
      "hashtags": "Hashtags"
    },
    "columns": {
      "title": "Title",
      "author": "Author",
      "categories": "Categories",
      "published": "Published",
      "scheduled": "Scheduled",
      "updated": "Updated"
    },
    "statusFilter": {
      "all": "All"
    },
    "statusLabels": {
      "draft": "Draft",
      "scheduled": "Scheduled",
      "published": "Published"
    },
    "posts": {
      "untitled": "(untitled)",
      "statusFilterLabel": "Filter by status",
      "createLabel": "+ Create Post",
      "emptyState": "No posts yet — click + Create Post to create one."
    }
  },
  "contact": {
    "title": "Contact",
    "description": "Configure the Contact form and manage submissions from the public site.",
    "tabsAriaLabel": "Tabs",
    "tabs": {
      "config": "Form Config",
      "submissions": "Submissions"
    },
    "fieldTypes": {
      "text": "Text (single line)",
      "multiline": "Multiline",
      "dropdown": "Dropdown",
      "single_choice": "Single choice",
      "multiple_choice": "Multiple choice"
    },
    "statusLabels": {
      "unread": "Unread",
      "read": "Read"
    },
    "toast": {
      "errorTitle": "Error"
    },
    "config": {
      "loadError": "Failed to load config",
      "newFieldLabel": "New field",
      "saveSuccess": "Form config saved",
      "saveError": "Save failed",
      "formFieldsHeading": "Form fields",
      "addFieldButton": "+ Add field",
      "loading": "Loading…",
      "emptyFields": "No fields yet. Click “Add field” to get started.",
      "labelPlaceholder": "Display label",
      "requiredLabel": "Required",
      "placeholderPlaceholder": "Placeholder (optional)",
      "optionsLabel": "Options (one per line)",
      "removeFieldButton": "Remove field",
      "saving": "Saving…",
      "saveButton": "Save form config"
    },
    "submissions": {
      "noNotificationBanner": "Note: the system does NOT send a notification when a new submission arrives. Admins must check this page regularly.",
      "loadError": "Failed to load submissions",
      "allStatuses": "All statuses",
      "searchPlaceholder": "Search by name / email",
      "searchButton": "Search",
      "loading": "Loading…",
      "empty": "No matching submissions.",
      "columns": {
        "status": "Status",
        "name": "Name",
        "email": "Email",
        "created": "Created",
        "actions": "Actions"
      },
      "viewButton": "View",
      "markReadError": "Update failed",
      "postNoteError": "Failed to post note",
      "noteAdded": "Note added",
      "detailTitle": "Submission from {{name}}",
      "responsesHeading": "Responses",
      "noResponses": "No data.",
      "adminNotesHeading_one": "Admin note ({{count}})",
      "adminNotesHeading_other": "Admin notes ({{count}})",
      "noNotes": "No notes yet.",
      "adminFallback": "admin",
      "notePlaceholder": "Add a reply note…",
      "posting": "Sending…",
      "addNoteButton": "Add note",
      "closeButton": "Close"
    }
  },
  "ebooks": {
    "title": "Ebooks",
    "description": "PDF download landing pages (fixed layout).",
    "status": {
      "draft": "Draft",
      "published": "Published",
      "archived": "Archived"
    },
    "actions": {
      "add": "Add ebook",
      "edit": "Edit",
      "delete": "Delete",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…"
    },
    "filters": {
      "allStatuses": "All statuses",
      "searchPlaceholder": "Search by name",
      "searchButton": "Search"
    },
    "list": {
      "loading": "Loading…",
      "empty": "No ebooks yet."
    },
    "table": {
      "name": "Name",
      "description": "Description",
      "status": "Status",
      "created": "Created",
      "creator": "Creator",
      "downloads": "Downloads",
      "url": "URL",
      "actions": "Actions"
    },
    "dialog": {
      "addTitle": "Add ebook",
      "editTitle": "Edit ebook"
    },
    "form": {
      "name": "Name",
      "namePlaceholder": "Ebook title",
      "slug": "Slug",
      "slugPlaceholder": "my-ebook",
      "description": "Description",
      "status": "Status",
      "contentBlocksTitle": "Content blocks (fixed layout)",
      "coverImage": "Cover image",
      "coverHelper": "PNG / JPEG ≤ 5 MB",
      "file": "File (PDF)",
      "fileHelper": "PDF ≤ 25 MB",
      "introduction": "Introduction",
      "extraBlocks": "Extra blocks (JSON object) — advanced",
      "extraPlaceholder": "{\"chapters\": [...]}",
      "publicUrl": "Public URL:"
    },
    "toast": {
      "saved": "Ebook saved",
      "deleted": "Deleted",
      "errorTitle": "Error"
    },
    "confirm": {
      "delete": "Delete this ebook?"
    },
    "errors": {
      "loadFailed": "Failed to load ebooks",
      "saveFailed": "Save failed",
      "deleteFailed": "Delete failed",
      "formInvalid": "Invalid form",
      "extraJsonNotObject": "extra_json must be a JSON object",
      "extraJsonInvalid": "extra_json is not valid JSON: {{message}}"
    }
  },
  "faq": {
    "title": "FAQ",
    "description": "Manage frequently asked questions shown as an accordion on the homepage. Drag and drop to reorder; edit in a modal.",
    "status": {
      "draft": "Draft",
      "published": "Published"
    },
    "actions": {
      "create": "Create new FAQ",
      "edit": "Edit",
      "delete": "Delete",
      "cancel": "Cancel",
      "close": "Close",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "saving": "Saving…",
      "saveChanges": "Save changes",
      "creating": "Creating…",
      "createSubmit": "Create FAQ"
    },
    "list": {
      "loading": "Loading…",
      "empty": "No FAQs yet."
    },
    "table": {
      "order": "Order",
      "question": "Question (EN)",
      "category": "Category",
      "status": "Status",
      "actions": "Actions"
    },
    "modal": {
      "createTitle": "Create new FAQ",
      "editTitle": "Edit FAQ"
    },
    "form": {
      "question": "Question ({{locale}})",
      "answer": "Answer ({{locale}})",
      "answerPlaceholder": "Detailed answer…",
      "category": "Category",
      "categoryPlaceholder": "e.g. Billing",
      "sortOrder": "Sort order",
      "status": "Status"
    },
    "confirm": {
      "delete": "Delete this FAQ?"
    },
    "errors": {
      "generic": "Error",
      "questionRequired": "Question (EN) is required.",
      "answerRequired": "Answer (EN) is required."
    }
  },
  "footer": {
    "title": "Footer",
    "description": "Manage the categories and items shown in the public site footer.",
    "categories": {
      "title": "Categories",
      "add": "+ Add",
      "loading": "Loading…",
      "empty": "No categories yet."
    },
    "items": {
      "title": "Items",
      "add": "+ Add item",
      "selectPrompt": "Select a category to view its items.",
      "loading": "Loading…",
      "empty": "No items yet."
    },
    "itemType": {
      "internal_page": "Internal",
      "external_link": "External"
    },
    "actions": {
      "edit": "Edit",
      "delete": "Delete",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…"
    },
    "category": {
      "editTitle": "Edit category",
      "addTitle": "Add category",
      "confirmDelete": "Delete this footer category?"
    },
    "item": {
      "editTitle": "Edit item",
      "addTitle": "Add item",
      "confirmDelete": "Delete this footer item?"
    },
    "form": {
      "slug": "Slug",
      "slugPlaceholder": "ex: company",
      "name": "Name ({{locale}})",
      "description": "Description ({{locale}})",
      "sortOrder": "Sort order",
      "type": "Type",
      "typeInternal": "Internal Page",
      "typeExternal": "External Link",
      "pageSlug": "Page slug",
      "pageSlugPlaceholder": "about-us",
      "fieldTitle": "Title ({{locale}})",
      "content": "Content ({{locale}})",
      "url": "URL",
      "urlPlaceholder": "https://example.com"
    },
    "toast": {
      "errorTitle": "Error",
      "categorySaved": "Category saved",
      "itemSaved": "Item saved",
      "deleted": "Deleted",
      "saveFailed": "Save failed",
      "deleteFailed": "Delete failed",
      "reorderFailed": "Reorder failed",
      "loadCategoriesFailed": "Could not load footer categories",
      "loadItemsFailed": "Could not load footer items"
    }
  },
  "helpCenter": {
    "breadcrumbHome": "Home Management",
    "breadcrumbCurrent": "Help Center",
    "title": "Help Center",
    "description": "Manage Topics → Articles for the Help Center (drag-and-drop sorting, EN/VI/FR i18n, preview in a new tab).",
    "status": {
      "draft": "Draft",
      "published": "Published"
    },
    "topics": {
      "regionLabel": "Help Topics",
      "title": "Topics",
      "create": "New topic",
      "searchLabel": "Search topics",
      "searchPlaceholder": "Search by name…",
      "statusFilterLabel": "Filter by status",
      "allStatuses": "All statuses",
      "colDragHandle": "Drag handle",
      "colTopic": "Topic",
      "colArticles": "Articles",
      "colStatus": "Status",
      "colActions": "Actions",
      "loading": "Loading…",
      "empty": "No topics yet. Click \"New topic\" to get started.",
      "dragToReorder": "Drag to reorder",
      "untitled": "Untitled topic",
      "edit": "Edit",
      "delete": "Delete",
      "preview": "Preview"
    },
    "articles": {
      "regionLabel": "Articles",
      "selectPrompt": "Select a topic on the left to view its articles.",
      "back": "Back to Topics",
      "topicFallback": "Topic",
      "heading": "{{name}} — Articles",
      "count_one": "{{count}} article",
      "count_other": "{{count}} articles",
      "create": "New article",
      "colDragHandle": "Drag handle",
      "colQuestion": "Question",
      "colStatus": "Status",
      "colSort": "Sort",
      "colActions": "Actions",
      "loading": "Loading…",
      "empty": "No articles in this topic yet.",
      "dragToReorder": "Drag to reorder",
      "untitled": "Untitled article",
      "edit": "Edit",
      "delete": "Delete",
      "preview": "Preview"
    },
    "toast": {
      "cannotDeleteTopicTitle": "Cannot delete topic",
      "cannotDeleteTopicDesc": "This topic still has articles. Remove or reassign its articles before deleting the topic.",
      "confirmDeleteTopic": "Delete topic \"{{name}}\"?",
      "topicDeleted": "Topic deleted.",
      "confirmDeleteArticle": "Delete article \"{{name}}\"?",
      "articleDeleted": "Article deleted.",
      "loadTopicsFailed": "Could not load the topic list.",
      "loadArticlesFailed": "Could not load articles.",
      "deleteTopicFailed": "Could not delete the topic.",
      "deleteArticleFailed": "Could not delete the article.",
      "sortTopicsFailed": "Could not sort topics.",
      "sortArticlesFailed": "Could not sort articles."
    }
  },
  "homepage": {
    "title": "Homepage",
    "description": "Manage homepage content. Each tab has its own save button — only the saved tab sends a PATCH to the server.",
    "tablistLabel": "Homepage tabs",
    "unsavedConfirm": "The current tab has unsaved changes. Do you want to leave this tab?",
    "unsavedDot": "Unsaved",
    "unsavedTitle": "Unsaved changes",
    "tabs": {
      "hero": "Hero",
      "best_selling": "Best-Selling",
      "block1": "Block 1",
      "block2": "Block 2",
      "block3": "Block 3",
      "block4": "Block 4",
      "banner": "Banner",
      "email_popup": "Email Popup",
      "about_us": "About Us",
      "categories": "Categories",
      "contact_form": "Contact Form",
      "faq": "FAQ",
      "static_info_2": "Static Info 2"
    },
    "common": {
      "saving": "Saving...",
      "saveTab": "Save {{name}}",
      "add": "+ Add",
      "delete": "Delete",
      "unsavedBadge": "Unsaved changes",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "linkUrl": "Link URL"
    },
    "errors": {
      "loadFailed": "Unable to load Homepage"
    },
    "footer": {
      "label": "Note:",
      "note": "Static Info 1, Fixed Image and the Hero background are hard-coded (developer config) per P8.D-396 — a code PR is required to change them."
    },
    "readOnlyAuto": {
      "heading": "Auto-derived",
      "bestSellingNote": "This tab shows the top 5 best-selling products over the last 30 days, automatically updated from orders.",
      "block3Note": "This tab shows the top 3 newest products, automatically updated.",
      "hardCoded": "(Hard-coded — developer config)"
    },
    "block": {
      "saveError": "Unable to save block",
      "title": "Title",
      "imageUrl": "Image URL"
    },
    "categories": {
      "saveError": "Unable to save Categories",
      "description": "List of categories/collections shown on the Homepage. Use the arrow buttons to reorder (drag-and-drop with the category bundle arrives in Phase 9).",
      "idPlaceholder": "Category ID"
    },
    "faq": {
      "saveError": "Unable to save FAQ",
      "description": "Select published FAQs (task-33) to show on the Homepage. Enter a FAQ ID and click Add.",
      "idPlaceholder": "FAQ ID"
    },
    "staticInfo2": {
      "saveError": "Unable to save Static Info 2",
      "description": "Configure the Static Info 2 button CTA. Background + heading are hard-coded (developer config).",
      "buttonText": "Button text ({{locale}})"
    }
  },
  "pages": {
    "title": "Custom pages (Pages)",
    "descriptionBefore": "CRUD for custom static pages (about us, policies, special landings). URL format ",
    "descriptionAfter": "; the slug shares a namespace with stories/faq/blog/help.",
    "createButton": "Create new page",
    "genericError": "Error",
    "loading": "Loading…",
    "empty": "No pages yet.",
    "edit": "Edit",
    "delete": "Delete",
    "deleteConfirm": "Delete this page?",
    "columns": {
      "title": "Title",
      "slug": "Slug",
      "status": "Status",
      "updated": "Updated",
      "actions": "Actions"
    },
    "status": {
      "draft": "Draft",
      "published": "Published"
    },
    "validation": {
      "titleRequired": "Title (EN) is required.",
      "contentRequired": "Content (EN) is required."
    },
    "form": {
      "ariaLabel": "Page editor",
      "createTitle": "Create new page",
      "editTitle": "Edit page",
      "backLabel": "Back to list",
      "titleLabel": "Title ({{locale}})",
      "contentLabel": "Content ({{locale}})",
      "contentPlaceholder": "Write the page content…",
      "slugLabel": "Slug ({{locale}})",
      "slugAutoHint": " (auto from Title if left blank)",
      "slugHint": "Must be unique cross-type with stories/faq/blog/help. BE returns 409 SLUG_TAKEN on collision.",
      "statusLabel": "Status",
      "seoLegend": "SEO ({{locale}})",
      "metaTitle": "Meta title",
      "metaDescription": "Meta description",
      "cancel": "Cancel",
      "saving": "Saving…",
      "saveChanges": "Save changes",
      "creating": "Creating…",
      "create": "Create page"
    }
  },
  "stories": {
    "errors": {
      "generic": "Error"
    },
    "list": {
      "title": "Success Stories",
      "description": "Display the merchant success showcase on the homepage. Drag and drop to reorder, edit per language, and preview drafts before publishing.",
      "create": "Create new story",
      "loading": "Loading…",
      "empty": "No stories yet.",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "edit": "Edit",
      "delete": "Delete",
      "confirmDelete": "Delete this story?",
      "columns": {
        "order": "Order",
        "titleMerchant": "Title / Merchant",
        "status": "Status",
        "created": "Created",
        "actions": "Actions"
      }
    },
    "status": {
      "draft": "Draft",
      "published": "Published"
    },
    "form": {
      "editorAria": "Story editor",
      "editTitle": "Edit story",
      "createTitle": "Create new story",
      "back": "Back to list",
      "preview": "Preview (new tab)",
      "previewSaveFirst": "Save the story before previewing.",
      "cancel": "Cancel",
      "saving": "Saving…",
      "saveChanges": "Save changes",
      "creating": "Creating…",
      "createSubmit": "Create story",
      "errors": {
        "merchantNameRequired": "Merchant name (EN) is required.",
        "storyContentRequired": "Story content (EN) is required.",
        "photoUrlRequired": "Photo URL is required."
      },
      "fields": {
        "photoUrl": "Photo URL",
        "merchantName": "Merchant name",
        "storyContent": "Story content",
        "contentPlaceholder": "Write the story content…",
        "metricsHighlight": "Metrics highlight",
        "metricsPlaceholder": "e.g. \"300% revenue increase\"",
        "quote": "Quote",
        "status": "Status",
        "slug": "Slug",
        "slugPlaceholder": "auto from merchant name (EN)",
        "slugHint": "Slug shares a namespace across stories/faq/pages/blog/help.",
        "sortOrder": "Sort order"
      },
      "previewClose": "Close preview",
      "previewLabel": "Preview ({{locale}})",
      "previewUntitled": "Untitled"
    }
  },
  "sellerSurvey": {
    "noPermission": "You do not have access to the Seller Survey page. Required permission:",
    "title": "Seller Survey",
    "description": "Onboarding survey for merchants (singleton). The Config tab manages questions and targeting; the Results tab shows submitted responses and exports CSV. The survey currently lives at merchant onboarding Step 2.",
    "tablistAria": "Seller survey tabs",
    "tabs": {
      "config": "Config",
      "results": "Results"
    },
    "loading": "Loading…"
  }
}
